var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeo4JPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#66B245;}\n\t.st1{fill:#008CC1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.1,79.2c11.2,0,20.2,9.1,20.2,20.2c0,11.2-9.1,20.2-20.2,20.2c-11.2,0-20.2-9.1-20.2-20.2 C32.9,88.2,41.9,79.2,53.1,79.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.9,8.6c7.2,0,13,5.8,13,13s-5.8,13-13,13s-13-5.8-13-13S28.7,8.6,35.9,8.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,50.5c0.1-0.4,0.1-0.8,0.1-1.3c0-0.1,0-0.3,0-0.4c0-0.5,0.1-1,0.1-1.6c0-0.7,0-1.3-0.1-2 c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.1-1.3-0.3-1.9c0-0.1,0-0.1,0-0.2c-2.1-11.7-12.2-20.5-24.5-20.5c-13.7,0-24.9,11.2-24.9,24.9 s11.1,24.9,24.9,24.9c12.6,0,22.9-9.3,24.6-21.5C112.7,50.7,112.7,50.6,112.7,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.4,62.6c-4.8,6.6-12.5,11-21.3,11c-14.5,0-26.2-11.8-26.2-26.2c0-14.5,11.8-26.2,26.2-26.2 c1.2,0,2.4,0.1,3.5,0.2c-8.2-6.6-18.6-10.5-30-10.5c-4.9,0-9.6,0.7-14.1,2.1c1.8,2.4,2.9,5.5,2.9,8.7c0,8.1-6.6,14.6-14.6,14.6 c-5.1,0-9.7-2.7-12.3-6.7c-6.2,8.1-9.9,18.2-9.9,29.2c0,15.2,7.1,28.7,18.1,37.5c1.5-10.4,10.5-18.4,21.3-18.4 c11.9,0,21.6,9.7,21.6,21.6c0,2-0.3,3.9-0.8,5.7C93.2,100,107.8,83.1,109.4,62.6z M67.2,18.2c2.1,0,3.8,1.7,3.8,3.8 s-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8S65,18.2,67.2,18.2z M27.3,43c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8 c0,2.1-1.7,3.8-3.8,3.8C29,46.8,27.3,45.1,27.3,43z M27.9,53.5c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8 S27.9,55.6,27.9,53.5z M30.3,64.7c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8c0,2.1-1.7,3.8-3.8,3.8C32,68.5,30.3,66.8,30.3,64.7 z M39.3,78.5c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C43.2,76.8,41.5,78.5,39.3,78.5z M57.1,22.4 c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8C60.9,20.7,59.2,22.4,57.1,22.4z M80.4,92.5 c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8S82.5,92.5,80.4,92.5z M87.4,84.2c-2.1,0-3.8-1.7-3.8-3.8 s1.7-3.8,3.8-3.8c2.1,0,3.8,1.7,3.8,3.8S89.5,84.2,87.4,84.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo4JPlain);
export default __webpack_public_path__ + "static/media/neo4j-plain.eed2b4def73151f2aca3a463f67d3126.svg";
export { ForwardRef as ReactComponent };